module.exports = __webpack_public_path__ + "static/WEDDING E&M-362-a7381ee99ccd0fe4b432580a7ddd38ae.jpg";